/* eslint-disable max-len */
/* eslint-disable react/no-array-index-key */
/* eslint-disable eqeqeq */
import React, { useCallback, useEffect, useState, useRef } from 'react';
import PropTypes from 'prop-types';
import { connect, useSelector, shallowEqual, useDispatch } from 'react-redux';
import swal from 'sweetalert';
import _, { isArray } from 'lodash';
import { mapDispatchToProps } from '../../../store/externalCalls/api/formApi';
import { composeURL, checkObjectAttributes } from '../../../utils/urlTools';
import PageTitle from '../../organisms/pageTitle/pageTitle';
import SimplePageTitle from '../../molecules/pageTitle/pageTitle';
import { storeStructure } from '../../../store/reducers';
import FormGroup from '../../organisms/formGroup/formGroup2';
import FormGroupExpansion from '../../organisms/formGroup/formGroupExpansion';
import { updateForm as basicUpdateForm } from '../../../store/actions/formActions';
import FooterButton from '../../molecules/formFooter/formFooter';
import PreventTransitions from '../../molecules/preventTransitions/preventTransitions';
import { resetError } from '../../../store/actions/errorActions';
import { updateAdditionalMetadata } from '../../../store/actions/additionalMetadataActions';
import { createSession, removeSession } from '../../../store/actions/sessionActions';
import Broadcast from '../../../store/externalCalls/broadcast';
import FormUploadSync from '../../molecules/formUploadSync/formUploadSync';
import LoadFromCatalogButton from '../../molecules/loadFromCatalogButton/loadFromCatalogButton';
import { ButtonTheme } from '../../atoms/button/button';
import MainHubPageTitle from '../../organisms/mainHubPageTitle/mainHubPageTitle';
import Toaste from '../../atoms/toast/toaste';
import { getCookie } from '../../../store/sessionStore';
import { encrypt } from '../../../utils/credentialsEncryption';
import { decryptText } from '../../../utils/cookies';
import alertIcon from '../../atoms/customIcons/alert-icon-orange.png';
import redIcon from '../../atoms/customIcons/alert-icon-red.png';
import tickIcon from '../../atoms/customIcons/alert-icon-green.png';
import './formTemplate.scss';
import { useParams, useLocation, useNavigate, useOutletContext, useRevalidator } from 'react-router-dom';

let stopSocketMessages = false;

const FormTemplate = (props) => {
  const {
    getItem,
    getAdditionalMetadata,
    getNewDefaults,
    resetAdditionalMetadata,
    resetForm,
    updateItem,
    updateLocalItem,
    updateAllItems,
    updateItemWithRefresh,
    deleteItem,
    createItem,
    formEdited,
    configFile,
    pagePermissions,
  } = (props);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const { revalidate } = useRevalidator();
  const session = useSelector((state) => state[storeStructure.Session], shallowEqual);
  const values = useSelector((state) => state[storeStructure.FormData]);
  const itemChanged = useSelector((state) => state.session.isBlocking);

  const contextLoaderData = useOutletContext() || {};
  const { changeAppRedirectTo, sportRoomId, configs, currentconfigId, onChangeMainHubConfig, mainHubConfigRef, setIsSpaceSelectDisabled } = contextLoaderData;
  const updateForm = configFile.customAction ? configFile.customAction : basicUpdateForm;

  const [disableForm, setDisableForm] = useState(false);
  const [websocketLogOpen, setWebsocketLogOpen] = useState(false);
  const [errors, setErrors] = useState({});
  const label = configFile.label ? configFile.label : '';
  const [userNavigation, setUserNavigation] = useState([]);
  const [hasPermissions, setHasPermissions] = useState(null);
  const [hasBlockedPermissions, setHasBlockedPermissions] = useState(null);
  const serializedState = getCookie('state');

  const errorRef = useRef(null);
  const initialValuesRef = useRef(null);

  const additionalMetadata = useSelector(
    (state) => state[storeStructure.AdditionalMetadata], shallowEqual,
  );
  let id = configFile.idAttribute !== undefined
    ? window.location.pathname.split('/')[window.location.pathname.split('/').length - 1]
    : undefined;
    id = id ?? contextLoaderData?.[configFile.id];
    const stripVolatileFields = (obj) => {
    if (!obj) return obj;
    const {
      created_at,
      updated_at,
      ...rest
    } = obj;
    return rest;
  }

  const isHtmlEmpty = (html) => {
    if (!html) return true;
    const container = document.createElement('div');
    container.innerHTML = html;
    const text = (container.textContent || container.innerText || '').replace(/\s|\u00A0/g, '');
    return text.length === 0;
  };

  const handlerOnPopupOpenned = (value) => {
    //if(value==false){
    /*if(storeSocketMessages.length>0){
      runSocketMessages(storeSocketMessages);
    }
    if(storeSocketNavigationMessages.length>0){
      // console.log("run stored",storeSocketNavigationMessages);
      runSocketNavigationMessages(storeSocketNavigationMessages);
    }*/
    //}
    // stopSocketMessages=value;
  }
  const addProtocolToLinks = (html) => {
    if (!html) return '';
    const container = document.createElement('div');
    container.innerHTML = html;
    const anchors = container.querySelectorAll('a[href]');
    anchors.forEach((a) => {
      const href = (a.getAttribute('href') || '').trim();
      if (!href) return;

      const hasProtocol =
        /^(https?:)?\/\//i.test(href) ||
        href.startsWith('mailto:') ||
        href.startsWith('tel:') ||
        href.startsWith('#');

      if (!hasProtocol) {
        a.setAttribute('href', `https://${href}`);
      }
    });

    return container.innerHTML;
  };
  const sanitizeHtmlFields = (obj) => {
    if (!obj) return obj;
    const clone = _.cloneDeep(obj);
    if (clone.description != null) {
      let desc = addProtocolToLinks(clone.description);
      if (isHtmlEmpty(desc)) {
        desc = '';
      }
      clone.description = desc;
    }
    return clone;
  };
  const prepareForCompare = (obj) => sanitizeHtmlFields(stripVolatileFields(obj));
  const savedCallback = () => {
    swal({
      title: 'Good job!',
      text: 'The form was saved!',
      icon: 'success',
    }).then(() => {
      if (configFile.redirectUrl) {
        navigate(configFile.redirectUrl);
        return;
      }
      if (configFile.goBackUrl) {
        navigate(composeURL(session, configFile.sessionParams, configFile.goBackUrl), {
          replace: true,
          state: {
            from: location.pathname,
          },
        });
        return;
      }

      if (configFile.goBack) {
        navigate(-1);
      }
    });
    formEdited(false);
  };

  const handlerErrors = (e) => {
    const messages = e.errors === undefined ? { general: 'Something was wrong' } : e.errors;
    setErrors(messages);
    setTimeout(() => {
      setErrors({});
    }, 10000);
    setDisableForm(false);
  };

  const delayedQuery = useCallback(_.debounce((valueChanged, updateRedux = false) => {
    const { url, ...rest } = valueChanged;
    dispatch(updateForm(valueChanged));
    if (id !== 'new') {
      const idToUpdate = valueChanged.id ? valueChanged.id : id;
      updateItem(composeURL(session, configFile.sessionParams, configFile.updateURL, idToUpdate), rest, updateRedux)
        .then({}, (e) => {
          const url = composeURL(session, configFile.sessionParams, configFile.getURL, id);
          getItem(url);
          handlerErrors(e);
        });
    } else {
      formEdited();
    }
  }, 300), [session, configFile]);

  const delayedAdditionalMetadataQuery = useCallback(_.debounce((valueChanged, dictionaryIndex) => {
    dispatch(updateAdditionalMetadata(valueChanged, dictionaryIndex));
    if (id !== 'new') {
      updateItem(`${composeURL(session, configFile.sessionParams, configFile.additionaMetadataURL)}/${id}`, additionalMetadata)
        .then({}, (e) => {
          handlerErrors(e);
        });
    } else {
      formEdited();
    }
  }, 300), [session, configFile, additionalMetadata]);

  const handlerUpdateWithRefresh = (valueChanged) => {
    const newValues = valueChanged;
    const { url, ...rest } = newValues;
    if (id !== 'new') {
      updateItem(`${composeURL(session, configFile.sessionParams, configFile.updateURL)}/${values.id}`, rest)
        .then((result) => {
          dispatch(updateForm(result));
        }, (e) => {
          handlerErrors(e);
        });
    } else {
      dispatch(updateForm(newValues));
      formEdited();
    }
  };


  const handlerCreateWithRefresh = (valueChanged) => {
    const newValues = { ...values, ...valueChanged };
    const { url, ...rest } = newValues;
    if (id !== 'new') {
      updateItemWithRefresh(`${composeURL(session, configFile.sessionParams, configFile.updateURL)}/${values.id}`, rest)
        .then(() => {
          // dispatch(updateForm(newValues));
          if (configFile.revalidate)
            revalidate();
        }, (e) => {
          handlerErrors(e);
        });
    } else {
      dispatch(updateForm(newValues));
      formEdited();
    }
  };

  const handlerOnChange = (valueChanged) => {
    if (!valueChanged) return;

    const propertyName = Object.keys(valueChanged)[0];
    let updateRedux = false;

    if (propertyName && configFile.updateReduxWhen && configFile.updateReduxWhen.includes(propertyName)) {
      updateRedux = true;
    }

    const newValues = { ...values, ...valueChanged };
    if (!valueChanged.isFilter) {
      if (configFile.autoUpdate == false || configFile.autoUpdate == undefined) {
        dispatch(updateForm(newValues));
        formEdited(true);
      } else {
        delayedQuery(newValues, updateRedux);
      }
    }
    else {
      dispatch(updateForm(newValues));
    }

    stopSocketMessages = true;
  };

  /**
   * Function to create a new item when the form is on expansion mode
   */
  const handlerOnClickNewItem = (arrayWithNewItem) => {
    swal({
      title: 'Are you sure?',
      text: 'You are about to insert a new item.',
      icon: 'warning',
      buttons: true,
      dangerMode: true,
    }).then((willAdd) => {
      if (willAdd) {
        updateItem(composeURL(session, configFile.sessionParams, configFile.updateURL, id), arrayWithNewItem)
          .then((result) => {
            dispatch(updateForm(result));
          }, (e) => {
            const url = composeURL(session, configFile.sessionParams, configFile.getURL, id);
            getItem(url);
            handlerErrors(e);
          });
      }
    });

  }
  const handlerUploadSync = () => {
    if (configFile.importMonitoringChanel) {
      setWebsocketLogOpen(true);
    } else {
      window.location.reload();
    }
  };
  const handleOnCloseLoadFromCatalog = (data) => {
    if (data !== undefined) {
      window.location.reload();
    }
  };
  const handlerOnChangeAdditionalMetadata = (valueChanged, dictionaryIndex) => {
    delayedAdditionalMetadataQuery(valueChanged, dictionaryIndex);
  };
  const handlerNoPermission = () => {
    swal({
      title: 'Can´t do this action!',
      text: 'You don´t have enough permission to do this action. Please contact to the admin asking for permissions',
      icon: 'warning',
      buttons: false,
      dangerMode: true,
    });
  }
  const handlerOnDelete = (valueDeleted, attributeName) => {
    const urlName = attributeName;
    if (id !== 'new') {
      swal({
        title: 'Are you sure?',
        text: 'You are removing a item.',
        icon: 'warning',
        buttons: true,
        dangerMode: true,
      }).then((willDelete) => {
        if (willDelete) {
          deleteItem(`${composeURL(session, configFile.sessionParams, urlName)}/${valueDeleted.id}`)
            .then(() => {
              const url = composeURL(session, configFile.sessionParams, configFile.getURL, id);
              getItem(url);
            }, (e) => {
              handlerErrors(e);
            });
        }
      });
    } else {
      const updatedValues = values[attributeName].filter((item) => {
        return item != valueDeleted
      });
      const newValues = { ...values };
      newValues[attributeName] = updatedValues;
      dispatch(updateForm(newValues));
      formEdited();
    }
  };

  const handlerOnDeleteExpasion = (idToDelete, urlName, parentId) => {
    swal({
      title: 'Are you sure?',
      text: 'You are removing a item.',
      icon: 'warning',
      buttons: true,
      dangerMode: true,
    }).then((willDelete) => {
      if (willDelete) {
        deleteItem(`${composeURL(session, configFile.sessionParams, urlName, parentId)}/${idToDelete}`)
          .then(() => {
            const url = composeURL(session, configFile.sessionParams, configFile.getURL, id);
            getItem(url, initialValuesRef);
          }, (e) => {
            handlerErrors(e);
          });
      }
    });
  }

  const handlerOnChangeItemPosition = (item) => {
    const url = composeURL(session, configFile.sessionParams, configFile.removeURL, item.id);
    updateItemWithRefresh(url, { ...item, toOrder: true }, dispatch).then(() => {
    }, (e) => {
      handlerErrors(e);
    });
  };
  /**
   * Create a object with attributes required by the config file and default value
   * @param {*} values
   */
  const pushAllValues = () => {
    // Encrypt the accessKey and secretKey
    let accessKey = '';
    let secretKey = '';
    let privateKey = '';
    let allValues = {};
    let externalResources = []

    if(values.storageProvider=='awsS3' || values.storageProvider=='externalGCS' || values.storageProvider=='wasabiS3' )
    {
      values.externalResources.forEach((resource) => {
        accessKey = encrypt(resource.accessKey)
        secretKey = encrypt(resource.secretKey)
        externalResources.push({ ...resource, accessKey: accessKey, secretKey: secretKey })
      });

      allValues = { ...values, externalResources: externalResources }
    }
    else if(values.originType=='S3' || values.originType=='GCS' || values.originType=='WASABI') {
      secretKey = encrypt(values.secretKey)
      allValues = { ...values, secretKey: secretKey }
    }
    else if (values.originType == 'SFTP') {
      privateKey = encrypt(values.privateKey)
      allValues = { ...values, privateKey: privateKey }
    }
    else {
      allValues = values
    }

    const formConfigs = Array.isArray(configFile.formConfig)
      ? configFile.formConfig : [configFile.formConfig];
    formConfigs.forEach((formConfig) => {
      formConfig.fields.forEach((field) => {
        if (allValues[field.attributeName] === undefined && field.default) {
          allValues[field.attributeName] = field.default;
        }
      });
    });

    return allValues;
  };
  const saveAction = (newElement) => {
    // Update additional metadata for the new Element
    if (additionalMetadata && additionalMetadata.length > 0) {
      updateItem(`${composeURL(session, configFile.sessionParams, configFile.additionaMetadataURL)}/${newElement.id}`, additionalMetadata);
      savedCallback();
    } else {
      if (configFile.updateFormAfterSave && newElement) {
        const newValues = { ...values, ...newElement };

        dispatch(updateForm(newValues));
      }
      savedCallback();
    }
  }
  const callbackOfButtonSave = (newElement) => {
    let newValuesAfterSave = values;
    if (configFile.updateFormAfterSave && newElement) {
      newValuesAfterSave = { ...values, ...newElement };
      dispatch(updateForm(newValuesAfterSave));
    }
    initialValuesRef.current = prepareForCompare(newValuesAfterSave);
    dispatch(createSession({ isBlocking: false }));
    formEdited(false);
    if (configFile.reconfirmMessage) {
      swal({
        title: 'Are you sure?',
        text: configFile.reconfirmMessage,
        icon: 'warning',
        buttons: true,
        dangerMode: true,
      }).then((willSave) => {
        if (willSave) {
          saveAction(newElement);

        }
        setDisableForm(false);
      });
    } else {
      saveAction(newElement);
      setDisableForm(false);
    }
  };
  const handlerCancelButton = () => {
    window.location.reload();
  }
  const handlerSaveButton = () => {
    setErrors({});
    dispatch(resetError());
    setDisableForm(true);
    if (id === 'new') {
      if (configFile.isMainHub) {
        createItem(`${composeURL(session, configFile.sessionParams, configFile.updateURL)}/${window.location.pathname.split('/')[window.location.pathname.split('/').length - 2]}`, pushAllValues())
          .then((newElement) => callbackOfButtonSave(newElement), (e) => handlerErrors(e));
      } else {
        createItem(composeURL(session, configFile.sessionParams, configFile.updateURL), pushAllValues())
          .then((newElement) => callbackOfButtonSave(newElement), (e) => handlerErrors(e));
      }
    } else {
      let url = composeURL(session, configFile.sessionParams, configFile.updateURL);
      if (configFile.idUpdate) {
        url = composeURL(session, configFile.sessionParams, configFile.updateURL, id);
      } else if (!configFile.noUpdateWithId) {
        url = `${composeURL(session, configFile.sessionParams, configFile.updateURL)}`;
      }
      updateItem(url, values)
        .then((updatedElement) => callbackOfButtonSave(updatedElement), (e) => handlerErrors(e));
    }
  };

  const handlerOnUpload = () => {
    setDisableForm(true);
  };

  const handlerOnCompletedUploadFiles = () => {
    setDisableForm(false);
  };

  const handlerOnCanceledUploadFiles = () => {
    setDisableForm(false);
  };

  const handlerReset = () => {
    resetForm();
    resetAdditionalMetadata();
  };

  const onBroncastingReceived = (e) => {
    if (configFile.websocketItems && Array.isArray(configFile.websocketItems)) {
      for (let item in configFile.websocketItems) {
        if (e.message[configFile.websocketItems[item]]) {
          updateLocalItem(e.message[configFile.websocketItems[item]], configFile.websocketItems[item]);
        }
      }
    } else if (configFile.websocketItem)
      updateLocalItem(e.message, configFile.websocketItem);
    else
      updateAllItems(e.message);
  };
  const handlerOnEdited = (value) => {
    dispatch(createSession({ isBlocking: value }))
  }
  const onBroadCastingFormGroupReceived = (e, item) => {
    updateLocalItem(e.message, item);
  }
  const onBroadCastingNavigationReceived = (e) => {
    let stateObj = JSON.parse(serializedState);
    let navURL = configFile.getURL;
    if (configFile.idAttribute)
      navURL = composeURL(null, null, configFile.getURL, id);    
    let pageUserNav = [];
    JSON.parse(e.data).forEach((item) => {
      if (item.page == process.env.REACT_APP_API_ENDPOINT + navURL) {
        if (item.email == stateObj.sessionEmail) {
          item.me = true;
        } else {
          item.me = false;
        }
        pageUserNav.push(item);
      }
    })
    setUserNavigation(pageUserNav);
  }
  const getChanges = (original, updated, path = '') => {
    const changes = {};

    const allKeys = new Set([
      ...Object.keys(original || {}),
      ...Object.keys(updated || {}),
    ]);

    for (const key of allKeys) {
      const currentPath = path ? `${path}.${key}` : key;

      const oldValue = original?.[key];
      const newValue = updated?.[key];

      const bothAreObjects =
        oldValue &&
        newValue &&
        typeof oldValue === 'object' &&
        typeof newValue === 'object' &&
        !Array.isArray(oldValue) &&
        !Array.isArray(newValue);

      if (bothAreObjects) {
        Object.assign(changes, getChanges(oldValue, newValue, currentPath));
      } else if (!_.isEqual(oldValue, newValue)) {
        changes[currentPath] = {
          from: oldValue,
          to: newValue,
        };
      }
    }

    return changes;
  };

  useEffect(() => {
    if (configFile.autoUpdate === undefined || configFile.autoUpdate === false) {
      stopSocketMessages = false;
      if (id === 'new') {
        stopSocketMessages = true;
        return;
      }
      if (!values || Object.keys(values).length === 0) return;
      const currentPrepared = prepareForCompare(values);
      const valueId = values?.id ?? null;
      const initId = initialValuesRef?.current?.id ?? null;
      if (!initialValuesRef.current || initId !== valueId) {
        initialValuesRef.current = currentPrepared;
        formEdited(false);
        return;
      }
      const baseline = initialValuesRef.current;
      const changes = getChanges(baseline, currentPrepared);
      const hasChanges = Object.keys(changes).length > 0;
      formEdited(hasChanges);
    }
  }, [configFile, values, id]);
  const sessionDependencies = configFile.sessionParams.map((param) => session[param],);
  const sessionDependenciesKey = JSON.stringify(sessionDependencies);
  useEffect(() => {
    if (pagePermissions) {
      const userPermissions = JSON.parse(decryptText(getCookie('userPermissions')));
      let Upermissions = userPermissions.map(permission => permission.description);
      let allowedPermissions = pagePermissions.filter(page =>
        Upermissions.some(p => page.data.includes(p))
      );
      let blockedPermissions = pagePermissions.filter(page =>
        !Upermissions.some(p => page.data.includes(p))
      );
      setHasBlockedPermissions(blockedPermissions);
      setHasPermissions(allowedPermissions);
    }

    setErrors({});
    if (checkObjectAttributes(session, configFile.sessionParams)) {
      if (id !== 'new') {
        initialValuesRef.current = null;
        const url = composeURL(session, configFile.sessionParams, configFile.getURL, id);
        resetForm();
        getItem(url);
      }
      if (configFile.additionaMetadataURL) {
        const url = composeURL(
          session,
          configFile.sessionParams,
          configFile.additionaMetadataURL,
          id,
        );
        getAdditionalMetadata(url);
      }
      if (id == 'new' && configFile.newURL) {
        const urlDefaults = composeURL(
          session,
          configFile.sessionParams,
          configFile.newURL,
          id,
        );
        getNewDefaults(urlDefaults);
      }
    }
  }, [ session.idAttribute, 
    sessionDependenciesKey,
    //location
    navigate
    ]);
  useEffect(() => {
    if (errorRef.current) {
      errorRef.current.scrollIntoView({ block: 'end', behavior: 'smooth' });
    }
  }, [errors]);
  useEffect(() => {
    if (configFile.saveIdSessionNameAs && id != 'new') {
      const newSession = {};
      newSession[configFile.saveIdSessionNameAs] = id;
      dispatch(createSession(newSession));
      return () => {
        // Removing the sesion param for this form
        dispatch(removeSession(configFile.saveIdSessionNameAs));
      };
    }
  }, [id]);
  useEffect(() => {
    if (setIsSpaceSelectDisabled)
      setIsSpaceSelectDisabled(configFile.disableArea);
  }, [setIsSpaceSelectDisabled, configFile, location]);

  useEffect(() => {
    if (configFile.saveValueSessionParams && Array.isArray(configFile.saveValueSessionParams)) {
      const sessionData = {};

      configFile.saveValueSessionParams.forEach((key) => {
        if (values?.[key] !== undefined && values?.[key] !== null) {
          sessionData[key] = values[key];
        }
      });

      if (Object.keys(sessionData).length > 0) {
        dispatch(createSession(sessionData));

        return () => {
          Object.keys(sessionData).forEach((key) => {
            dispatch(removeSession(key));
          });
        };
      }
    }
  }, [values, configFile]);

  useEffect(() => {
    return () => {
      resetForm();
    };
  }, []);

  useEffect(() => {
    if (!session.mainHubConfigId && session.configId) {
      dispatch(createSession({
        ...session,
        mainHubConfigId: session.configId,
      }));
    }
  }, [session.configId]);
  return (
    <div>
      {configFile.websocketNavigation
        && (
          <Broadcast
            eventChanel={configFile.websocketNavigation}
            sessionParams={[]}
            onEventReceived={(e) => { onBroadCastingNavigationReceived(e); }}
          />
        )}
      {configFile.websocketChannel
        && (
          <Broadcast
            eventChanel={configFile.websocketChannel}
            sessionParams={configFile.websocketSessionParams}
            onEventReceived={(e) => { onBroncastingReceived(e); }}
          />
        )}
      {configFile.noArea
        && (
          <SimplePageTitle myEmail={JSON.parse(serializedState).sessionEmail} userNavigation={(userNavigation && userNavigation.length > 0 ? userNavigation : values.usersNavigation)}>{configFile.title}</SimplePageTitle>
        )}
      {(configFile.noArea === undefined || configFile.noArea === false) && (configFile.isMainHub === undefined || configFile.isMainHub === false)
        && (
          <PageTitle
            disableArea={configFile.disableArea == true ? true : false}
            disableConfig={configFile.disableArea == true ? true : false}
            myEmail={JSON.parse(serializedState).sessionEmail}
            userNavigation={(userNavigation.length > 0 ? userNavigation : values.usersNavigation)}
            operatingSystem={configFile.showOperatingSystem ? values.operatingSystem : ''}
            configs={configs || []}
            currentconfigId={currentconfigId}
            onChangeMainHubConfig={onChangeMainHubConfig}
            showMainHubConfigSelect={sportRoomId !== undefined}
            mainHubConfigRef={mainHubConfigRef}
          >
            {configFile.title}
          </PageTitle>
        )}
      {(configFile.noArea === undefined || configFile.noArea === false) && (configFile.isMainHub === true)
        && (
          <MainHubPageTitle configFile={configFile}>{configFile.title}</MainHubPageTitle>
        )}
      {Object.keys(errors).length > 0
        && (
          <Toaste type="error" mode="toast" data={errors} />
        )}
      {(hasPermissions || hasBlockedPermissions) &&
        <div class={"form-template-permissions-block " + (hasPermissions.length == 0 ? "color-red" : hasPermissions.length == pagePermissions.length ? "color-green" : "color-orange")}>
          <div class="form-template-permission-icon"><img src={hasPermissions.length == 0 ? redIcon : hasPermissions.length == pagePermissions.length ? tickIcon : alertIcon} /></div>
          <div class="width-100">
            {hasPermissions.length == 0 && <div class="form-template-permissions-title">Restricted Access</div>}
            {hasPermissions.length > 0 && hasPermissions.length < pagePermissions.length && <div class="form-template-permissions-title">Limited Permissions</div>}
            {hasPermissions.length == pagePermissions.length && <div class="form-template-permissions-title">Full Permission Enabled</div>}
            {hasPermissions.length > 0 && hasPermissions.length < pagePermissions.length && <><div class="form-template-permissions-text">Some actions are restricted</div>
              <div class="form-template-permissions-items">
                <div class="form-template-permissions-list">
                  {hasPermissions.map((perm) => {
                    return <div class="form-template-inline form-template-permissions-text">{perm.name}: <span class="option">Yes</span></div>;
                  })}
                  {hasBlockedPermissions.map((blocked) => {
                    return <div class="form-template-inline form-template-permissions-text">{blocked.name}: <span class="option">No</span></div>;
                  })}

                </div>
              </div>
            </>}
            {hasPermissions.length == pagePermissions.length && <div class="form-template-permissions-text">You have full access on this page. Create, save, and delete actions are available.</div>}
            {hasPermissions.length == 0 && <div class="form-template-permissions-text">You do not have permission to perform key actions on this page. {pagePermissions.map(p => p.name).join(", ")} actions are disable.</div>}
          </div>
        </div>}

      {configFile.loadFromFile !== undefined
        && (
          <FormUploadSync
            endpoint={composeURL(session, configFile.sessionParams, configFile.loadFromFile, id)}
            helpText={configFile.loadFromFileHelp}
            fileExtensionType={configFile.fileExtensionType}
            onSuccess={handlerUploadSync}
          />
        )}
      {configFile.fromCatalogTable !== undefined
        && (
          <LoadFromCatalogButton
            label={label}
            configFile={configFile.fromCatalogTable}
            buttonTheme={ButtonTheme.PRIMARY}
            onClose={handleOnCloseLoadFromCatalog}
            multiple={configFile?.fromCatalogTableMultiple ?? false}
          />
        )}

      {Array.isArray(configFile.formConfig) === true
        && configFile.formConfig.map((formGroup, index) => {
          const childConfig = configFile?.formConfig?.[index];
          const shouldRenderAsExpansion =
            childConfig?.isExpand !== undefined
              ? childConfig.isExpand
              : configFile?.formGroupExpands === true;
          let visible = true;
          if (formGroup.visibleWhen) {
            if (Array.isArray(formGroup.visibleWhen)) {
              formGroup.visibleWhen.forEach((elArr) => {
                if (elArr.value === 'not-null') {
                  if (values?.[elArr.field] === 0 || values?.[elArr.field] === '' || values?.[elArr.field] === undefined) {
                    visible = false;
                  }
                  return;
                }

                if (values?.[elArr.field] !== elArr.value) {
                  visible = false;
                }
              });
            } else if (values?.[formGroup.visibleWhen.field] !== formGroup.visibleWhen.value) {
              visible = false;
            }
          }

          return (
            <div key={index}>
              {visible &&
                <>
                  {formGroup.websocketChannel &&
                    <Broadcast
                      eventChanel={formGroup.websocketChannel}
                      sessionParams={formGroup.websocketSessionParams}
                      onEventReceived={(e) => { onBroadCastingFormGroupReceived(e, formGroup.websocketItem); }}
                    />
                  }
                  {shouldRenderAsExpansion ?
                    (
                      <FormGroupExpansion
                        key={`${configFile.attributeName}-${formGroup.attributeName}`}
                        configFile={formGroup}
                        config={configFile}
                        value={values}
                        id={configFile.attributeName}
                        onChange={handlerOnChange}
                        onDelete={!pagePermissions ? handlerOnDeleteExpasion : hasPermissions && hasPermissions.find(p => p.name === "Delete") ? handlerOnDeleteExpasion : handlerNoPermission}
                        onChangeItemPosition={handlerOnChangeItemPosition}
                        onUpload={handlerOnUpload}
                        onCompletedUploadFiles={handlerOnCompletedUploadFiles}
                        onCanceledUploadFiles={handlerOnCanceledUploadFiles}
                        onClickNewItem={!pagePermissions ? handlerOnClickNewItem : hasPermissions && hasPermissions.find(p => p.name === "Create") ? handlerOnClickNewItem : handlerNoPermission}
                        session={session}
                        initialValuesRef={initialValuesRef}
                      />
                    ) : (<FormGroup
                      key={`${configFile.attributeName}-${formGroup.attributeName}`}
                      configFile={formGroup}
                      value={values}
                      onChange={handlerOnChange}
                      onUpdateWithRefresh={handlerUpdateWithRefresh}
                      onCreateWithRefresh={handlerCreateWithRefresh}
                      onDeleteInputRelationship={handlerOnDelete}
                      onChangeItemPosition={handlerOnChangeItemPosition}
                      onUpload={handlerOnUpload}
                      onCompletedUploadFiles={handlerOnCompletedUploadFiles}
                      onCanceledUploadFiles={handlerOnCanceledUploadFiles}
                      onEdited={handlerOnEdited}
                      onReset={handlerReset}
                      initialValuesRef={initialValuesRef}
                      onPopupOpenned={handlerOnPopupOpenned}
                    />)}
                </>}
            </div>
          );
        })}
      {configFile.formGroupExpands !== true && Array.isArray(configFile.formConfig) === false
        && (
          <FormGroup
            configFile={configFile.formConfig}
            value={values}
            onChange={handlerOnChange}
            onDeleteInputRelationship={!pagePermissions ? handlerOnDelete : (hasPermissions && hasPermissions.find(p => p.name === "Delete")) ? handlerOnDelete : handlerNoPermission}
            onChangeItemPosition={handlerOnChangeItemPosition}
            onUpload={handlerOnUpload}
            onCompletedUploadFiles={handlerOnCompletedUploadFiles}
            onCanceledUploadFiles={handlerOnCanceledUploadFiles}
            onReset={handlerReset}
            onPopupOpenned={handlerOnPopupOpenned}
          />
        )}
      {configFile.formGroupExpands === true && Array.isArray(configFile.formConfig) !== true
        && (
          <FormGroupExpansion
            configFile={configFile.formConfig}
            config={configFile}
            value={values}
            id={configFile.attributeName}
            onChange={handlerOnChange}
            onDelete={!pagePermissions ? handlerOnDeleteExpasion : hasPermissions && hasPermissions.find(p => p.name === "Delete") ? handlerOnDeleteExpasion : handlerNoPermission}
            onChangeItemPosition={handlerOnChangeItemPosition}
            onUpload={handlerOnUpload}
            onCompletedUploadFiles={handlerOnCompletedUploadFiles}
            onCanceledUploadFiles={handlerOnCanceledUploadFiles}
            onClickNewItem={!pagePermissions ? handlerOnClickNewItem : hasPermissions && hasPermissions.find(p => p.name === "Create") ? handlerOnClickNewItem : handlerNoPermission}
            session={session}
          />
        )}
      {additionalMetadata.map((additionalMetadataFormValues, key) => (
        <FormGroup
          key={`additionalMetadata-${key}`}
          configFile={additionalMetadataFormValues.formConfig}
          value={additionalMetadataFormValues.values}
          onChange={(valueChanged) => handlerOnChangeAdditionalMetadata(valueChanged, key)}
          onUpload={handlerOnUpload}
          onCompletedUploadFiles={handlerOnCompletedUploadFiles}
          onCanceledUploadFiles={handlerOnCanceledUploadFiles}
          onReset={handlerReset}
          onPopupOpenned={handlerOnPopupOpenned}
        />
      ))}
      <PreventTransitions />

      {itemChanged === true && (id == 'new' || configFile.autoUpdate == undefined || configFile.autoUpdate == false)
        && (
          <div className="footer-section">
            <FooterButton
              id={`${configFile.attributeName}-saveButton`}
              onClick={handlerSaveButton}
              floatPosition="right"
              disabled={disableForm || (hasPermissions && !hasPermissions.find(p => p.name === "Save"))}
            >
              {!disableForm && "Save"}
            </FooterButton>
            <FooterButton
              id={`${configFile.attributeName}-cancelButton`}
              onClick={handlerCancelButton}
              disabled={disableForm}
              floatPosition="left"
            >
              {!disableForm && "Cancel "}
            </FooterButton>
          </div>
        )}
    </div>
  );
};

FormTemplate.propTypes = {
  configFile: PropTypes.shape({
    attributeName: PropTypes.string,
    title: PropTypes.string,
    sessionParams: PropTypes.arrayOf(PropTypes.string),
    getURL: PropTypes.string,
    additionaMetadataURL: PropTypes.string,
    saveIdSessionNameAs: PropTypes.string,
    updateURL: PropTypes.string,
    removeURL: PropTypes.string,
    formConfig: PropTypes.oneOfType([PropTypes.shape({}), PropTypes.arrayOf(PropTypes.shape({}))]),
    idAttribute: PropTypes.string,
    autoUpdate: PropTypes.bool,
    noUpdateWithId: PropTypes.bool,
    updateFormAfterSave: PropTypes.bool,
    goBack: PropTypes.bool,
    noArea: PropTypes.bool,
    websocketChannel: PropTypes.string,
    websocketSessionParams: PropTypes.arrayOf(PropTypes.string),
    websocketItem: PropTypes.string,
    websocketItems: PropTypes.arrayOf(PropTypes.string),
  }).isRequired,
  getItem: PropTypes.func.isRequired,
  getAdditionalMetadata: PropTypes.func.isRequired,
  getNewDefaults: PropTypes.func,
  resetAdditionalMetadata: PropTypes.func.isRequired,
  resetForm: PropTypes.func.isRequired,
  updateItem: PropTypes.func.isRequired,
  updateLocalItem: PropTypes.func.isRequired,
  updateItemWithRefresh: PropTypes.func.isRequired,
  deleteItem: PropTypes.func.isRequired,
  createItem: PropTypes.func.isRequired,
  formEdited: PropTypes.func.isRequired,
  location: PropTypes.shape({
    pathName: PropTypes.string,
    search: PropTypes.string,
  }),
  match: PropTypes.shape({
    params: PropTypes.shape({}),
  }),
  history: PropTypes.shape({
    goBack: PropTypes.func,
  })
};

FormTemplate.defaultProps = {

};

export default (connect(null, mapDispatchToProps)(FormTemplate));